export default function () {
    if (document.body.classList.contains('single-product')) {
        document.getElementById("modal_ask_btn").onclick = function () {
            // this.preventDefault();
            document.getElementById('modal_ask').classList.add('active')
        }

        document.getElementById("modal_ask_close").onclick = function () {
            // this.preventDefault();
            document.getElementById('modal_ask').classList.remove('active')
        }
    }
}